import styled from "styled-components";

export const StyledAvatar = styled.img`
  height: 47px;
  width: 47px;
  object-fit: cover;
  margin-right: 1rem;
`;

export const DefaultAvatar = styled.div`
  height: 47px;
  width: 47px;
  background-color: ${(props) => props.theme.default.color.primary};
  margin-right: 1rem;
  color: white;
  font-size: 24px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
`;
